<template>
    <div>
        <div class="placeholder fit-content">
            <div class="placeholder__heading">
                {{ data.full_name }}
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="data.project_types"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="sortOptions"
                    :styleClass="styleClass"
                    @on-row-click="selectProjectType"
                    :row-style-class="selectedRowClass"
                    v-if="!loading"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'" >
                            {{ props.row.coverage_percent | coveragePercent }} 
                            <div
                                v-if="props.row.coverage_percent !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                            />
                        </div>
                        <div v-else-if="props.column.field == 'total_projects'" style="text-align:left;">
                            {{ props.row.total_projects }}
                        </div>
                        <div v-else-if="props.column.field == 'name'" class="table-column__description">
                            {{ props.row.name }}
                        </div>
                        <div v-else-if="props.column.field == 'coverage'" style="text-align:left;">
                            {{ props.row.coverage | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'invoices_total'" style="text-align:left;">
                            {{ props.row.invoices_total | currency }}
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                            {{ props.row.coverage_per_hour | currency }} 
                            <div
                                v-if="props.row.coverage_per_hour !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                            />
                        </div>
                        <div v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

            </div>
        </div>

        <br>

        <div v-if="!selectedRow">
            Vælg en opgavetype for at se de enkelte opgaver her
        </div>

        <div v-if="selectedRow">
            <employee-revenue-projects :data="selectedRow" v-if="selectedRow"></employee-revenue-projects>
        </div>

    </div>
</template>

<script>
export default {
    props: ['data'],
    data () {
        return {
            selectedRow: null,
            columns: [
                { label: 'Opgavetype', field: 'name', type: 'string' },
                { label: 'Antal opgaver', field: 'projects_count', type: 'number' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    methods: {
        selectProjectType (projectType) {
            this.selectedRow = projectType.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected'
            }
        }
    },
    watch: {
        data: function () {
            this.selectedRow = null
        }
    },
    components: {
        'employee-revenue-projects': require('./employeeRevenueProjects.vue')
    }
}
</script>



// WEBPACK FOOTER //
// employeeRevenueProjectTypes.vue?f532af70